module.exports = __webpack_public_path__ + "static/media/promise.318ac0db.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/promise.gif
// module id = 341
// module chunks = 0